import PropTypes from 'prop-types';
import { Box, Button } from '@material-ui/core';
import { Delete, Edit, Tune } from '@mui/icons-material';
import placeholder_illustration from 'assets/img/placeholder_illustration.png';
import GenericConfirmationCard from 'common/components/cards/genericConfirmationModel/genericConfirmationModel';
import PrimaryButton from 'common/components/buttons/primaryButton';
import GeneralGrid from 'common/components/layout/grid/GeneralGrid';
import LoadingProgress from 'common/components/progress/loading';
import Table from 'common/components/table/table-material';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getList, remove, getParentActions, saveParentActions } from './stationHierarchiesActions';
import ManageInheritedActivitiesModal from './ManageInheritedActivitiesModal';

export function StationHierarchies(props) {
  const { router } = props;
  const { list, loading, parentActions, parentActionsLoading, parentActionsSaving } =
    props.stationHierarchies;
  const [data, setData] = useState([]);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [itemID, setItemID] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [columns] = useState([
    { render: (rowData) => rowData?.station_name, title: 'Estação (filha)' },
    {
      render: (rowData) => rowData?.parent_station_name,
      title: 'Estação (pai)',
    },
    {
      render: (rowData) =>
        rowData?.total_action_station_hierarchies ? (
          <>
            <span style={{ color: 'purple', padding: '0 4px' }}>
              {`${rowData?.total_action_station_hierarchies}`}
            </span>
            atividade(s)
          </>
        ) : (
          'Todas'
        ),
      title: 'Atividades herdadas',
    },
    {
      field: 'actions',
      title: 'Ações',
      headerCenter: true,
      hasOnClick: true,
      render: (rowData) => (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, maxWidth: 200 }}>
          <Box sx={{ display: 'flex', gap: 0.5 }}>
            <Button
              size="small"
              onClick={() => {
                setSelectedItem(rowData);
                setOpenModal(true);
                props.getParentActions(rowData.id);
              }}
              sx={{ p: 1, minWidth: 'auto' }}
              title="Gerenciar">
              <Tune sx={{ fontSize: 18, color: '#666' }} />
            </Button>
            {!rowData?.total_action_station_hierarchies && (
              <Button
                size="small"
                onClick={() => router.push(`/owner/station-hierarchies/${rowData.id}/editar`)}
                sx={{ p: 1, minWidth: 'auto' }}
                title="Editar">
                <Edit sx={{ fontSize: 18, color: '#666' }} />
              </Button>
            )}
            <Button
              size="small"
              onClick={() => {
                setOpenConfirmation(true);
                setItemID(rowData.id);
              }}
              sx={{ p: 1, minWidth: 'auto' }}
              title="Excluir">
              <Delete sx={{ fontSize: 18, color: '#666' }} />
            </Button>
          </Box>
        </Box>
      ),
    },
  ]);

  useEffect(() => {
    props.getList(props.auth.user.establishments[0].stations[0].id);
  }, []);

  useEffect(() => {
    setData(props.stationHierarchies.list.content);
  }, [props.stationHierarchies.list.content]);

  function handleDelete(id) {
    props.remove(id, () => props.getList(props.auth.user.establishments[0].stations[0].id));
    setOpenConfirmation(false);
  }

  function renderEmptyScreen() {
    return (
      <section id="statement-buy-points" style={{ height: '100vh' }}>
        <GeneralGrid container spacing={3} alignItems="center">
          <GeneralGrid item xs={12} md={6}>
            <GeneralGrid container spacing={3}>
              <GeneralGrid item xs={12}>
                <h2 className="signup-text">
                  Você ainda não associou hierarquia para esta estação.
                </h2>
                <PrimaryButton onClick={() => props.router.push('/owner/station-hierarchies/novo')}>
                  Vincular hierarquia
                </PrimaryButton>
              </GeneralGrid>
            </GeneralGrid>
          </GeneralGrid>
          <GeneralGrid item xs={12} md={6}>
            <img
              src={placeholder_illustration}
              className="img-fluid"
              alt="Ilustração: não há dados"
            />
          </GeneralGrid>
        </GeneralGrid>
      </section>
    );
  }

  if (loading) {
    return (
      <Box display="flex" height="100vh" justifyContent="center" mt={7}>
        <LoadingProgress />
      </Box>
    );
  }
  if (list.content.length < 1) {
    return renderEmptyScreen();
  }
  return (
    <section id="stationHierarchies">
      <GenericConfirmationCard
        open={openConfirmation}
        loading={loading}
        general={props.general}
        title="Deletar vínculo hierárquico"
        confirmButtonColor={'primary'}
        text="Tem certeza? Você deletará o vínculo hierárquico dessa estação."
        cancelClose={() => setOpenConfirmation(false)}
        onClose={() => setOpenConfirmation(false)}
        onClick={() => {
          if (itemID) handleDelete(itemID);
        }}
      />
      <GeneralGrid container spacing={3}>
        <GeneralGrid item xs={12} style={{ width: isMobile ? '90vw' : undefined }}>
          <Table
            hasToolbar={false}
            defaultSelected={{}}
            title="Hierarquia da estação"
            columns={columns}
            rows={data}
            compressedTable
            mobileTable={isMobile}
            hasBorder={!isMobile}
          />
        </GeneralGrid>
      </GeneralGrid>
      <ManageInheritedActivitiesModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        stationName={selectedItem?.station_name || ''}
        activities={parentActions}
        selectedActionIds={selectedItem?.action_ids || []}
        loading={parentActionsLoading}
        saving={parentActionsSaving}
        onSave={(selected) => {
          if (selectedItem?.id) {
            props.saveParentActions(selectedItem.id, selected).then(() => {
              props.getList(props.auth.user.establishments[0].stations[0].id);
            });
          }
        }}
      />
    </section>
  );
}

StationHierarchies.propTypes = {
  auth: PropTypes.shape({
    user: PropTypes.shape({
      establishments: PropTypes.any,
    }),
  }),
  stationHierarchies: PropTypes.shape({
    list: PropTypes.shape({
      content: PropTypes.shape({
        length: PropTypes.number,
      }),
    }),
    loading: PropTypes.any,
    parentActions: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        createdAt: PropTypes.string,
      })
    ),
    parentActionsLoading: PropTypes.bool,
    parentActionsSaving: PropTypes.bool,
  }),
  getList: PropTypes.func,
  getParentActions: PropTypes.func,
  saveParentActions: PropTypes.func,
  router: PropTypes.shape({
    push: PropTypes.func,
  }),
}; // props.auth.user.establishments

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    general: state.general,
    stationHierarchies: state.stationHierarchies,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      remove,
      getList,
      getParentActions,
      saveParentActions,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(StationHierarchies);
